export const MENU_TAGS = {
  NEW: 'new',
  BETA: 'beta',
};

export const MENU_MODALS = {
  SEND_FEEDBACK_MODAL: 'sendFeedbackModal',
  ALGOLIA_SEARCH_MODAL: 'algoliaSearchModal',
};
